import React from "react";
import { Box, Stack, Button, Typography } from "@mui/material";

/**
 * AlphabetIndexBar
 *
 * Props:
 * @param {Array} letters - [{ key:'A', label:'A', count:12, targetId:'letter-A' }]
 * @param {string|null} activeKey - 현재 활성화된 키
 * @param {function} onClick - (key, targetId) => void
 * @param {number} offset - sticky 상단 오프셋
 * @param {boolean} hiddenOnMobile - 모바일에서 숨김 여부
 */
export default function AlphabetIndexBar({
  letters = [],
  activeKey = null,
  onClick,
  offset = 64,
  hiddenOnMobile = true,
}) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: offset,
        height: `calc(100vh - ${offset}px)`,
        display: hiddenOnMobile ? { xs: "none", md: "flex" } : "flex",
        alignItems: "center",
        px: { xs: 0, md: 1 },
        flexShrink: 0,
        alignSelf: 'flex-start',
        zIndex: (theme) => theme.zIndex.appBar - 2,
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        {letters.map((it) => {
          const selected = activeKey === it.key;
          return (
            <Button
              key={it.key}
              variant="text"
              size="small"
              onClick={() => onClick && onClick(it.key, it.targetId)}
              sx={{
                minWidth: 0,
                width: { xs: 32, md: 44 },
                height: { xs: 28, md: 36 },
                p: 0,
                color: selected ? "primary.main" : "text.secondary",
                fontWeight: selected ? 800 : 600,
                fontSize: { xs: "0.75rem", md: "0.875rem" },
              }}
            >
              {it.label}
            </Button>
          );
        })}
        <Typography
          variant="caption"
          sx={{ color: "text.disabled", mt: 0.5, fontSize: { xs: "0.625rem", md: "0.75rem" } }}
        >
          A–Z
        </Typography>
      </Stack>
    </Box>
  );
}


